// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__loS5S","large":"styles_large__1Isga"};